<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="activeDiscounts && activeDiscounts.length"
      class="font-bold"
    >
      {{ $t('Active discounts') }}
    </div>
    <div class="flex flex-col gap-2">
      <CartDiscountWarning />
      <DiscountCard
        v-for="discount in activeDiscounts"
        :key="discount.id"
        :discount="discount"
        :is-active="true"
        :has-partners-points="hasPartnersPoints(discount)"
        @click-delete-coupon="id => deleteCoupon(id)"
      >
        <CartPartnersPoints
          v-if="basketPoints && hasPartnersPoints(discount)"
          :basket-points="basketPoints"
          class="text-xs"
        />
      </DiscountCard>
    </div>
    <div
      v-if="inactiveDiscounts && inactiveDiscounts.length"
      class="font-bold"
    >
      {{ $t('Unlock more savings') }}
    </div>
    <div class="flex flex-col gap-2">
      <DiscountCard
        v-for="discount in inactiveDiscounts"
        :key="discount.id"
        :discount="discount"
        :is-active="false"
        :has-partners-points="hasPartnersPoints(discount)"
      >
        <CartPartnersPoints
          v-if="basketPoints && hasPartnersPoints(discount)"
          :basket-points="basketPoints"
          shows-level-discount
          class="text-xs"
        />
      </DiscountCard>
    </div>
    <CartCoupon v-if="showCouponInput" />
  </div>
</template>

<script lang="ts">


import {
  getCartDiscounts,
  getDiscountCodeByCouponId,
} from '~~/helpers/cart/cartDiscountGetter';
import type { MappedDiscount } from '~~/types/discounts';
import { CUSTOM_QUERIES } from '~~/constants/customQueries';
import { UNLOCKABLE_CART_DISCOUNT_KEYS } from '~~/constants/cartDiscounts';
import { DISCOUNT_CATEGORY } from '~~/types/discounts';

export default defineComponent({
  name: 'CartDiscountSection',

  props: {
    showCouponInput: {
      type: Boolean,
      default: true,
    },
  },



  setup() {

    const {
      cart,
      removeCoupon,
    } = useCartExtended();

    const { lineItems, loadVolumeDiscounts } = useLineItems();
    const { load: loadLoyaltyLevels } = useCTLoyaltyLevels();
    const { load: loadCartDiscounts } = useCartDiscountsStore();
    const { inactiveDiscounts } = useInactiveDiscounts();
    const { basketPoints } = useBasketPartnersPoints();

    const activeDiscounts = computed(() => getCartDiscounts(cart.value));

    const deleteCoupon = (couponId: MappedDiscount['id']) => {

      const couponCode = getDiscountCodeByCouponId(cart.value, couponId);
      removeCoupon({
        couponCode,
        customQuery: CUSTOM_QUERIES.UPDATE_CART_CUSTOM,
      });

    };

    const hasPartnersPoints = (discount: MappedDiscount) =>
      discount.category === DISCOUNT_CATEGORY.LOYALTY && !!basketPoints.value?.points;

    const lineItemsLength = computed(() => !!lineItems.value?.length);

    watch(lineItemsLength, () => {

      loadVolumeDiscounts();
      loadLoyaltyLevels();
      loadCartDiscounts(UNLOCKABLE_CART_DISCOUNT_KEYS);

    }, { immediate: true });

    return {
      activeDiscounts,
      inactiveDiscounts,
      deleteCoupon,
      basketPoints,
      hasPartnersPoints,
    };

  },
});

</script>
